import { updateMemberPersonalDetails } from './update-member-personal-details';
export const updateMemberLanguageTagPreference = async (languageTag) => {
    return updateMemberPersonalDetails({ preferences: { languageTag } }, undefined);
};
//# sourceMappingURL=update-member-language-tag-preference.js.map